import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'created_at', label: 'created_at' },
  { id: 'updated_at', label: 'updated_at' },
  { id: 'liquidity', label: 'liquidity' },
  { id: 'volume', label: 'volume' },
  { id: 'volume_24hr', label: 'volume_24hr' },
  { id: 'volume_1wk', label: 'volume_1wk' },
  { id: 'volume_1mo', label: 'volume_1mo' },
  { id: 'volume_1yr', label: 'volume_1yr' },
  { id: 'one_hour_price_change_abs', label: 'one_hour_price_change_abs' },
  { id: 'one_day_price_change_abs', label: 'one_day_price_change_abs' },
  { id: 'one_week_price_change_abs', label: 'one_week_price_change_abs' },
  { id: 'one_month_price_change_abs', label: 'one_month_price_change_abs' },
  { id: 'spread', label: 'spread' },
  { id: 'null', label: 'None' },
];

const STRICT_FILTER_TYPE_OPTIONS = [
  { id: 'item_ids', label: 'Item Ids' },
  { id: 'wallet_prefs1', label: 'Wallet Preferences' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'tags', label: 'Tags' },
  { id: 'date', label: 'Date Range' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const BOOST_FILTER_TYPE_OPTIONS = [
  { id: 'boost_wallet_labels', label: 'Wallet Labels' },
  { id: 'boost_wallet_tags', label: 'Wallet Tags' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'tags', label: 'Tags' },
  { id: 'date', label: 'Date Range' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const PolymarketItemsQuery = () => {
  return (
    <QueryModes
      source="polymarket-items"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={STRICT_FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={BOOST_FILTER_TYPE_OPTIONS}
    />
  );
};

export default PolymarketItemsQuery;

